module.exports = [{
      plugin: require('/home/circleci/repo/node_modules/gatsby-mdx/gatsby-browser'),
      options: {"plugins":[],"extensions":[".mdx"],"gatsbyRemarkPlugins":["gatsby-remark-prismjs"]},
    },{
      plugin: require('/home/circleci/repo/node_modules/gatsby-plugin-web-font-loader/gatsby-browser'),
      options: {"plugins":[],"google":{"families":["Space Mono:400,700","Source Sans Pro:200,400,700","Source Code Pro:400,400i,700,700i"]}},
    },{
      plugin: require('/home/circleci/repo/node_modules/gatsby-plugin-google-gtag/gatsby-browser'),
      options: {"plugins":[],"trackingIds":["UA-120672950-1","AW-801403098"],"gtagConfig":{"anonymize_ip":true,"cookie_expires":0},"pluginConfig":{"head":true,"respectDNT":true}},
    },{
      plugin: require('/home/circleci/repo/node_modules/gatsby-plugin-facebook-pixel/gatsby-browser'),
      options: {"plugins":[],"pixelId":"717652705365586"},
    },{
      plugin: require('/home/circleci/repo/node_modules/gatsby-plugin-twitter-pixel/gatsby-browser'),
      options: {"plugins":[],"pixelId":"o2dy0"},
    },{
      plugin: require('/home/circleci/repo/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
